import Vue from 'vue';
if(window.Vue) {
	Vue = window.Vue;
} else {
	window.Vue = Vue;
}
import $ from 'jquery';
if(!window.$) {
	window.$ = window.jQuery = $;
}

import vuetify from '../js/plugins/vuetify';
import Vuelidate from 'vuelidate';
import '../js/mixins/index';
require('intersection-observer-polyfill/dist/IntersectionObserver.global');
import '../PlicCanvas/vue/utils/common-css.css';
import '../PlicCanvas/vue/utils/external-scripts';
import '../PlicCanvas/vue/utils/registerServiceWorker';
import '../PlicCanvas/vue/common/common-libs';
import '../PlicCanvas/vue/common/common-components';
import '../PlicCanvas/vue/common/legacy/flow-layout';

Vue.config.productionTip = false;
Vue.use(Vuelidate);

import Uploader from '../PlicCanvas/vue/uploader/Uploader';
import { acceptedFileExtensions, photoConverters } from '../vue/utils/photo-converters';
Vue.component('candid-uploader', Uploader);

import ButtonUploader from '../PlicCanvas/vue/uploader/ButtonUploader';
Vue.component('button-uploader', ButtonUploader);

window.Vuetify = vuetify;
window.webpack_acceptedFileExtensions = acceptedFileExtensions;
window.webpack_photoConverters = photoConverters;

import pdfjsLib from 'pdfjs-dist';
window.pdfjsLib = pdfjsLib;

import DictionaryManagement from '../PlicCanvas/vue/project-management/DictionaryManagement';
Vue.component('dictionary-management', DictionaryManagement);

import 'jsbarcode';
// Couldn't get a working version on npm - probably need to port to a separate library to get updating
import '../PlicCanvas/js/lib/qrcode';
import 'linkify-jquery';

import '../js/changelog.js';
import '../js/tutorials/book-composer';
import '../js/tutorials/management';
import '../js/tutorials/tutorials';
import '../js/common/globals';

import '../css/common.css';